import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LoadMoreAnalysesButton = ({ handleLoadMore }) => {
  const { t } = useTranslation();

  return (
    <Box textAlign="center">
      <Button variant="outlined" onClick={handleLoadMore} size="large">
        {t('loadMore')}
      </Button>
    </Box>
  );
};

export default LoadMoreAnalysesButton;
